import React, { useEffect, useRef, useState } from "react";
import Header from "../components/global/Header";
import LeftNavbar from "../components/global/LeftNavbar";
import { Link, useParams, useNavigate,useLocation } from "react-router-dom";
import { getAxiosResponse,postAxiosResponse,putAxiosResponse } from "../services/authApiRoutes/APImethods";
import {projectCreationStepFilter } from '../redux/reducers/ProjectCreationStepSlice';
import {  useTranslation } from 'react-i18next';
import { updateTargetLanguage } from "../redux/reducers/CreateProjectTargetLanguageSlice";
import { updateSourceLanguage } from "../redux/reducers/CreateProjectSourceLanguageSlice";
import { departmentSelected } from "../redux/reducers/CreateProjectDepartmentSelectSlice";
import { updateProjectFollowers } from "../redux/reducers/ProjectInfoSlice";
import { updateInitializedProjectWorkflows } from "../redux/reducers/InitializedProjectWorkflowsSlice";
import { updateProjectInfoConfiguration } from "../redux/reducers/ProjectInfoConfigurationSlice";
import { updateProjectInfoValidation } from "../redux/reducers/ProjectInfoValidationSlice";
import { updateProjectInfo} from "../redux/reducers/ProjectInfoSlice";
import { confirmAlert } from "react-confirm-alert";
import { updateSourceFiles } from "../redux/reducers/SourceFilesSlice";
import { updateCustomerBootstrapData } from "../redux/reducers/CustomerBootstrapDataSlice";
import {  useSelector, useDispatch } from "react-redux";
import {Overview} from "../components/project/projectDetail/Overview";
import ProjectDetailTab from "../components/project/projectDetail/ProjectDetailTab";
import SourceFile from "../components/project/projectDetail/SourceFile";
import Bids from "../components/project/projectDetail/Bids";
import Estimate from "../components/project/projectDetail/Estimate";
import TranslationRequest from "../components/project/projectDetail/TranslationRequest";
import InternalTranslator from "../components/project/projectDetail/InternalTranslator";
import Tasks from "../components/project/projectDetail/Tasks";
import ChangeOrder from "../components/project/projectDetail/ChangeOrder";
import Discussion from "../components/project/projectDetail/Discussion";
import { RotatingLines } from "react-loader-spinner";
import Constants from "../Constants";
import { transformBlankToNull } from "../services/Util";
import { compareDateWithCurrent,dateFormat,utcDateTimeWithTimeZoneWithFormat } from "../services/Util";
import { campaignDetailDate } from "../services/Util";
import SuccessMessage from "../components/SuccessMessage";
import icons from "../icons";
import APIUrls from "../services/APIUrls";
import $ from "jquery";
import { TourProvider } from "@reactour/tour";
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'
import "@reactour/popover/dist/index.css";
import steps from "../services/tourJson/project-details";
import { updateProjectEditMessage } from "../redux/reducers/ProjectEditMessageSlice";
import { getLoggedInUserRole } from "../services/Util";
import { Breadcrumb } from "../components/dashboard/Breadcrumb";
import { updateContentType } from "../redux/reducers/CreateProjectContentTypeSlice";
import { updateSelectedProjectWorkflow } from "../redux/reducers/SelectedProjectWorkflowSlice";
import AddProjectTemplate from "../components/project/projectDetail/AddProjectTemplate";
import ErrorMessage from "../components/ErrorMessage";
import { updateAsyncUploadAssetInProgressFiles, updateAsyncUploadAssetPendingFiles, updateCanSubmitTranslation, updateReadyForValidation, updateValidationErrors } from "../redux/reducers/AsyncAssetUploadSlice";
import { setSelectedTreeData } from "../redux/reducers/TreeSlice";
import { updateOldTargetLanguage } from "../redux/reducers/OldTargetLanguageSlice";
import { ConditionalBlock } from "../ConditionalBlock";
import LeveragedTm from "../components/project/projectDetail/LeveragedTm";
import { updateAllUserGroupFollowers, updateFollowersCollection } from "../redux/reducers/ProjectFollowersSlice";
import {RotatingLinesIcon} from "../AppIcons";

export default function ProjectDetail() {
	const { t } = useTranslation();
  const location = useLocation();
  const [state,setLocationState] = useState(location.state);
  const translate = t;
  const [trigger, setTrigger] = useState('');
  const navigate = useNavigate();
  const [activeTab, setActiveSection] = useState("overView");
  const [projectData, setProjectData] = useState([]);
  const [recentActivity, setRecentActivity] = useState([]);
  const [alertRedirect, setAlertRedirect] = useState(false);
  const [permission, setPermission] = useState({});
  const [feature, setFeatures] = useState({});
  const [langCode,setLangCode] = useState('')
  const [taskId,setTaskId] = useState('')
  const [changeOrderId,setChangeOrderId] = useState('')
  const [discussionsId,setDiscussionsId] = useState('')
  const [unreadDiscussionCount,setCount] = useState(0);
  const [showLoader,setShowLoader] = useState(true)
  const [showProjectStatusLoader,setShowProjectStatusLoader] = useState(false)
  const [refreshProjectData,setRefreshProjectData]=useState("")
  const [errorMsg,setErrorMsg] = useState("");
  const [templateExist,setTemplateExist]=useState(true);
  const scrollRef = useRef(null);
  const dispatch = useDispatch();
  const custBootstrapDataRedux = useSelector((store) => store.customer_bootstrap_data).value;
  const hideModel = () => {document.body.classList.remove("modal-open");};
  function showHide() {
    var element = document.getElementById("progress-btn");
    if(element !==undefined && element !==null){
      element.classList.toggle("show");
      $('.circle').attr('aria-expanded', function(index, attr){
        return attr === 'true' ? 'false': 'true';
      });
      $(document).mouseup(function(e) {
        var bannerCont = $('.name-card-section-right');
        if (!bannerCont.is(e.target) && bannerCont.has(e.target).length === 0) {
          showHide()
        }
      });
    }
  }
  const isOnlyReviewer = () => {
    if(roleArray.includes('ROLE_CUSTOMER_REVIEWER') && roleArray.length==1){
    return true;
    }
    return false;
  }

  const decreaseMessageCount = () => {
    setCount(unreadDiscussionCount - 1);
  }

const handleDotEscFocus = (event) => {
  if (event.key === Constants.ESCAPE && event.target.ariaExpanded === 'true') {
    showHide()
    $(".projectDeatilsDot").trigger("focus");
  }
  if (event.key === Constants.ENTER) {
    showHide()
  }
  if (event.key === Constants.TAB && event.shiftKey && event.target.ariaExpanded === 'true') {
    setTimeout(() => {
      $(".projectDeatilsDot").trigger("focus");
    });
    showHide()
   
  }
}
const handleDotModalFocus = (event) => {
  if (event.key === Constants.ESCAPE) {
    showHide()
    $(".projectDeatilsDot").trigger("focus");
  }
  if (document.activeElement.id === 'cloneProject') {
    if (event.key === Constants.TAB && event.shiftKey) {
      event.preventDefault();
      showHide()
      $(".projectDeatilsDot").trigger("focus");
    }
}
if (document.activeElement.id === 'cancelProject') {
    if (event.key === Constants.TAB && !event.shiftKey) {
      event.preventDefault();
      showHide()
      $(".projectDeatilsDot").trigger("focus");
    }
}
}
  const showLangDetail = (e,langCode) =>{
    e.preventDefault()
    setTrigger(langCode);
  };

  const showModel = () => {
    document.body.classList.add("modal-open");
  };

  const roleArray = getLoggedInUserRole();
  const reference1 = useRef(null);
  const reference2 = useRef(null);
  const [openProj, setOpenProj] = useState(false);
  const queryParams = new URLSearchParams(window.location.search);
  const queryParamValue = queryParams?.get('value');
  const [successMsg,setSuccessMsg] = useState("");
  const param = useParams();
  const openAddProjPopup = () => {
    setOpenProj(true);
    showModel();
  };

  const checkIsRedirect = () => {
    if(document.URL.includes("/messages/create")) {
      setActiveSection("discussions");
      setAlertRedirect(true);
    }
  };
  const clearStateOpenTab = () =>{
    setLocationState(null)
    setLangCode('')
    navigate(location.pathname, {}); 
    setActiveSection("overView")
  }
  useEffect(()=>{
    if(state !== null && state.tab){
      setActiveSection(state.tab)
      if(state.tab === 'discussions' && state.id){
        setActiveSection("discussions")
        setDiscussionsId(state.id)
      }
      if(state.tab === 'changeOrder' && state.id){
        setActiveSection("changeOrder")
        setChangeOrderId(state.id)
      }
      if(state.langCode)
      {
      setLangCode(state.langCode)
      }  
      if(state.tab==='overview' && state.id){
       setActiveSection("overView")
      }
      if(state.tab==='leverage-tm' && state.id)
      {
        setActiveSection("leverage-tm")
      }
    }    
  }
,[state])

useEffect(()=>{

if(param.tab){
  redirectToTab(param.tab)
}
if(queryParamValue==="changeOrder"){
  setActiveSection("changeOrder")
}
getCustomerPermission()
},[])

  useEffect(()=>{
    if (projectEditMessage?.editProjectSubmitStatus) {
      setTimeout(() => {
        $('.lastdisable').trigger('focus');
      }, 2000);
    } else {
      $('.lastdisable').trigger('focus');
    }
  }, [showLoader]);

  const redirectToTab = (val,langCode) =>{
    if(val === "createNewDiscussion"){
      setAlertRedirect(true);
      setActiveSection('discussions')
    }else if(langCode){
      setLangCode(langCode)
      setActiveSection(val)
    }
    else{
      setActiveSection(val)
      setTimeout(() => {
        $('button.active').trigger('focus');
      }, 300);
    }
  }
  const redirectToActivity = (e,activity) =>{
    if(activity.action?.length <= 0){return;}
    var url = e.target.href || activity.action[0].url
    var urlParts = url.split("/")
    const urlLastPart = url.split("/").pop()
    const urlSecondLast = urlParts[urlParts?.length -2]
    if(urlSecondLast === 'vendors'){
      navigate(`/${urlSecondLast}/${urlLastPart}`)
    }else{
      if(activity.action !== '' && activity.action?.length > 0){
        url = activity.action[0]?.url?.substring(activity.action[0]?.url)
      }
      if(url !== '' ){
      const urlLastPart = url.split("/").pop()
      var urlParts = url.split("/")
      const urlSecondLast = urlParts[urlParts?.length -2]
      if(e.target.href === e.target.baseURI || 
        activity.recentActivityVO.languageCode !== '' || 
        urlLastPart === 'translationRequest' || urlSecondLast === 'changeOrder' ||
        urlLastPart === 'bids' || urlSecondLast === 'discussions' || urlSecondLast === 'tasks' || urlLastPart === 'internalTranslator'
        ){
          e.preventDefault()
          if(activity.recentActivityVO.languageCode !== ''){
            setLangCode(activity.recentActivityVO.languageCode)
            setActiveSection('overView')
          }
          else if(urlLastPart === 'translationRequest' || urlLastPart === 'bids' || urlLastPart === 'internalTranslator'){
            setActiveSection(urlLastPart)
          }
          else if(urlSecondLast === 'changeOrder'){
            setChangeOrderId(urlLastPart)
            setActiveSection(urlSecondLast)
          }
          else if(urlSecondLast === 'discussions'){
            setDiscussionsId(urlLastPart)
            setActiveSection(urlSecondLast)
          }
          else if(urlSecondLast === 'tasks' || urlSecondLast === 'task'){
            setTaskId(urlLastPart)
            setActiveSection(urlSecondLast)
          }
        }
      }else{
        if(e.target.href === e.target.baseURI){
          e.preventDefault()
          window.scrollTo(0,0);
        }
      }
    }
  }
  const navigateBack = () => {
    navigate("/projects");
  };

  const cloneProject = () =>{
    postAxiosResponse(APIUrls.CLONE_PROJECT(param.id))
    .then((res) => {
      dispatch(setSelectedTreeData([]))
      dispatch(projectCreationStepFilter("Source Material Step 1"))               
      dispatch(updateReadyForValidation(false));
      dispatch(updateSourceLanguage({}));	
      dispatch(updateTargetLanguage([]));	   
      dispatch(updateOldTargetLanguage([]))
      dispatch(departmentSelected(""));
      dispatch(updateProjectFollowers([]));
      dispatch(updateInitializedProjectWorkflows([]));
      dispatch(updateSelectedProjectWorkflow({}));
      dispatch(updateProjectInfoValidation({}));
      dispatch(updateProjectInfoConfiguration({}));
      dispatch(updateProjectInfo({}));
      dispatch(updateValidationErrors([]));
      dispatch(updateCanSubmitTranslation(true));
      let newProjectId = res?.data?.data?.id
      navigate(`/createProject/${newProjectId}?projectType=clone&label=${projectData?.resource?.projectResource?.userGroup?.name}&value=${projectData?.resource?.projectResource?.userGroup?.id}`);
    }).catch(err=>{
      console.error(err)
    })
  };

  const cancelProject = () =>{
    var projectResource = projectData.resource.projectResource;
    var payload = {...projectResource, status: "CANCELLED"}
    var finalPayload = transformBlankToNull(payload)
    putAxiosResponse(APIUrls.PROJECT(param.id),finalPayload)
    .then((res) => {
      refreshProject()
    }).catch(err=>{
      console.error(err)
    })
  };

  const handleEscapeInPopup = (event) => {};
  const handleClickOutsidePopup = (event) => {};
  const handleFocusOutsidePopup = (event) => {};
  const projectConfigurationStatus = [
    'configured_project_name',
    'uploaded_source_materials',
    'configured_bid_options',
    'configured_project_workflow','configured_project_details'
  ];

  useEffect(() => {
    document.addEventListener("click", handleClickOutsidePopup, true);
    document.addEventListener("focus", handleFocusOutsidePopup, true);
    document.addEventListener("keydown", handleEscapeInPopup, true);
    return () => {
      document.removeEventListener("click", handleClickOutsidePopup, true);
      document.removeEventListener("focus", handleFocusOutsidePopup, true);
      document.removeEventListener("keydown", handleEscapeInPopup, true);
    };
  }, [reference1, reference2]);

	const projectEditMessage = useSelector((projectEditMessageSlice) => projectEditMessageSlice.project_edit_message_slice).value;

  useEffect(()=>{
     setTimeout(()=>{
      let msg = projectEditMessage.ownerStatus ? projectEditMessage.message : (projectEditMessage.editProjectSubmitStatus ? Constants.PROJECT_UPDATE_SUCCESS_MESSAGE : Constants.BLANK);
      setSuccessMsg(msg);
      dispatch(updateProjectEditMessage({editProjectSubmitStatus:false,ownerStatus:false,message:""}));
     },5000)
  },[]);

  useEffect(()=>{
    if (successMsg !== Constants.BLANK) {
      setTimeout(function () {
        setSuccessMsg(Constants.BLANK);
      }, 5000);
    }
  },[successMsg]);

  useEffect(()=>{
    if (errorMsg !== Constants.BLANK) {
      setTimeout(function () {
        setErrorMsg(Constants.BLANK);
      }, 5000);
    }
  },[errorMsg]);


  const refreshProject = (tab,refreshProjectStatus=false) =>{
    getProjectData(refreshProjectStatus);
    if(tab && tab !== ''){
      setActiveSection(tab);
    }
  }

  const getCustomerPermission = () => {
    setPermission(custBootstrapDataRedux?.permissions);
    setFeatures(custBootstrapDataRedux?.features);
  };

  const getActivityData = () => {
    getAxiosResponse(APIUrls.RECENT_ACTIVITY_PROJECT(param.id))
    .then((res) => {
      if (res.data !== "") {
        setRecentActivity(res.data.data)
        $('.lastdisable').trigger('focus');
            //setProjectData(res.data.data.projectResource);
        }
      })
  };

  const getProjectData = (refreshProjectStatus=false) =>{
    refreshProjectStatus?setShowProjectStatusLoader(true):setShowLoader(true)
    getAxiosResponse(APIUrls.PROJECT_DETAILS_WITH_CUSTOM_DATE(param.id))
      .then((res) => {
        if (res?.data !== "" && res?.data?.details === undefined) {
          const projectResourceData = res.data.data.resource.projectResource;
          let projectContentType = (projectResourceData.projectContentType === "" || projectResourceData.projectContentType === null) ?
            Constants.STANDARD : projectResourceData.projectContentType;
          dispatch(updateProjectInfo(projectResourceData));
          if(projectConfigurationStatus.includes(projectResourceData.status.code)){
            dispatch(updateContentType(projectContentType));
            dispatch(projectCreationStepFilter(Constants.SOURCE_MATERIAL_STEP_2));
            dispatch(updateReadyForValidation(false));
            dispatch(updateAsyncUploadAssetPendingFiles({}));
            dispatch(updateAsyncUploadAssetInProgressFiles([]));
            dispatch(setSelectedTreeData([]));
            dispatch(updateValidationErrors([]));
            navigate(`/createProject/${projectResourceData.id}`);
          }
          const data = res.data.data;
          setShowLoader(false)

          if (refreshProjectStatus) {
            let updatedStatus = data?.resource?.projectResource.status
            let displayName = data?.displayName;

            const updatedProjectData = {
              ...projectData,
              displayName: displayName,
              resource: {
                ...projectData?.resource,
                projectResource: {
                  ...projectData?.resource?.projectResource,
                  status: updatedStatus
                }
              }
            };

            setProjectData(updatedProjectData);
            setShowProjectStatusLoader(false)
          } else {
            setProjectData(data);
            const count = data?.resource?.tabs?.filter((t) => t?.display === "Discussions")[0].count;
            setCount(count);
            if (projectResourceData.projectTemplateId === "") {
              getTemplateifPresent(projectResourceData.id);
            }
          }
        }
        else if(res.data.details && res.data.details.status === false){
          navigate("/unauthorized");
        }
      }).catch(err=>{
        console.error(err)
      })
      getActivityData();
  };

  const showTabWithId = (tab,id) =>{
    if(tab==='changeOrder'){
      setChangeOrderId(id)
    }
    if(tab === 'overView'){
      setLangCode(id)
    }
    if(tab === 'tasks' || tab === 'task'){
      setTaskId(id)
    }
    setActiveSection(tab)
  }

const showCancelProjectPopup = () =>{
  setTimeout(() => {
    $("#deleteNo").trigger("focus");
    $("#react-confirm-alert").attr( { role:"dialog", 'aria-modal':"true", 'aria-label':"Cancel Project" } );
  }, 500);
  var msg = 'Canceling a project cannot be undone. Are you sure you want to cancel?';
      confirmAlert({
        title: "Cancel Project",
        message: <p>{`${msg}`}</p>,
        buttons: [
          {
            label: "Yes",
            id: "deleteYes",
            onClick: () => cancelProject(),
            onKeyDown: (e) => {
              if (e.key === "Tab") {
                if (e.shiftKey === true) {
                  e.preventDefault();
                  $("#deleteNo").trigger("focus");
                }
              }
            },
          },
          {
            label: "No",
            id: "deleteNo",
            onClick: () => {
              showHide()
              $('.projectDeatilsDot').trigger('focus');
           },
            onKeyDown: (e) => {
              if (e.key === "Tab") {
                if (e.shiftKey === false) {
                  e.preventDefault();
                  $("#deleteYes").trigger("focus");
                }
              }
              if (e.key === Constants.ESCAPE) {
                showHide()
                $('.projectDeatilsDot').trigger('focus');
              }
            },
          }
      ],
      closeOnEscape: true,
      closeOnClickOutside: true,
      overlayClassName: "delete_overlay",
    });
  };

  // Save Project Template
  const showAddModal = () => {
    document.body.classList.add("modal-open-9");
  };

  useEffect(() => {
    getProjectData();
    checkIsRedirect();
  }, [param.id]);

  const getTemplateifPresent = (projectId)=>{
      getAxiosResponse(APIUrls.PROJECT_TEMPLATE_BY_PROJECT_ID(projectId))
      .then((response)=>{
        const data = response.data.data;
        if(data && data !== "" && data.id!==""){
          setTemplateExist(false);
        }else{
          setTemplateExist(true);
        }
      }).catch((err)=>{
        console.error(err);
      });
    }

  const editProject=(e)=>{
    dispatch(updateProjectInfo(""));
    if (e.type==="click" || e.key===Constants.ENTER) {
      navigate(`/project-details-edit/${param.id}`,{state:{langData:projectData.displayName[0]}});
    }
    
  }
 //Tutorial Tips start
function doArrow(position, verticalAlign, horizontalAlign) {
  if (!position) {
    return {};
  }
 const width = 16;
  const height = 12;
  const color = "white";
  const isVertical = position === "top" || position === "bottom";
  const spaceFromSide = 10;

  const obj = {
    [`--rtp-arrow-${
      isVertical ? opositeSide[horizontalAlign] : verticalAlign
    }`]: height + spaceFromSide + "px",
    [`--rtp-arrow-${opositeSide[position]}`]: -height + 2 + "px",
    [`--rtp-arrow-border-${isVertical ? "left" : "top"}`]: `${
      width / 2
    }px solid transparent`,
    [`--rtp-arrow-border-${isVertical ? "right" : "bottom"}`]: `${
      width / 2
    }px solid transparent`,
    [`--rtp-arrow-border-${position}`]: `${height}px solid ${color}`
  };
  return obj;
}
const styles = {
  popover: (base, state) => {
   return {
      ...base,
     ...doArrow(state.position, state.verticalAlign, state.horizontalAlign),
     '--reactour-accent': '#154da1',
     };
  }
  
};
const opositeSide = {
  top: "bottom",
  bottom: "top",
  right: "left",
  left: "right"
};
const prevButton= ({ currentStep, setCurrentStep, steps }) => {
  const first = currentStep === 0
  $(`.tutorial-left-arr + div button:nth-child(${currentStep + 1})`).trigger('focus')
  $(`.tutorial-left-arr + div button`).each(
    function(index, item){
      $(item).attr('aria-label','Go to step ' + (index + 1))
    }
  )
  $(`.tutorial-left-arr + div button:nth-child(${currentStep + 1})`).attr('aria-label','current step '+ (parseInt(currentStep,10) + 1))
  return (
    <button aria-label="go to previous" disabled={first ? "disabled" : ""} className={first ? "tutorial-left-arr tutorial-disable" : "tutorial-left-arr"}
      onClick={() => {
        if (first) {
          setCurrentStep((s) => steps.length - 1)
        } else {
          setCurrentStep((s) => s - 1)
        }
      }}
    >
      <svg viewBox="0 0 18.4 14.4"><path d="M1.4 7.2h16M7.6 1L1.4 7.2l6.2 6.2" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-miterlimit="10"></path></svg>
    </button>
  )
 };
 const nextButton= ({ currentStep, setCurrentStep, steps, stepsLength, setIsOpen }) => {
  const last = currentStep === stepsLength - 1
  $(`.tutorial-left-arr + div button:nth-child(${currentStep + 1})`).trigger('focus')
  $(`.tutorial-left-arr + div button`).each(
    function(index, item){
      $(item).attr('aria-label','Go to step ' + (index + 1))
    }
  )
  $(`.tutorial-left-arr + div button:nth-child(${currentStep + 1})`).attr('aria-label','current step '+ (parseInt(currentStep,10) + 1))
  return (
    <>
    {last ? (
      <button className="finish-btn"
        onClick={() => {
        if (last) {
          setIsOpen(false)
        } else {
          setCurrentStep((s) => (s === steps?.length - 1 ? 0 : s + 1))
        }
       }}
      >Finish</button>
    ) : (
      <button aria-label="go to next" disabled={last ? "disabled" : ""} className={last ? "tutorial-right-arr tutorial-disable" : "tutorial-right-arr"}
      onClick={() => {
        if (last) {
          setIsOpen(false)
        } else {
          setCurrentStep((s) => (s === steps?.length - 1 ? 0 : s + 1))
        }
       }}
      >
      <svg viewBox="0 0 18.4 14.4"><path d="M17 7.2H1M10.8 1L17 7.2l-6.2 6.2" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-miterlimit="10"></path></svg>
      </button>
    )}
    </>
  )

 }
const getAssigneeDisplay = (phase) =>{
  var assigneeDisplay = ''
  if (phase.assigneeType.originalEnum === "VENDOR" || phase.assigneeType.originalEnum === "MACHINE_TRANSLATOR") {
    if (phase.phaseType.originalEnum === "POST_EDITING") {
      assigneeDisplay = phase.assigneeVendor.name;
    } else if (phase.phaseType.originalEnum === "WORK" || phase.phaseType.originalEnum === "REVIEW") {
      var project = projectData.resource.projectResource
      assigneeDisplay = project.translationEngineType?.display ? project.translationEngineType?.display :
        project.vendor?.name ? project.vendor.name : phase.assigneeType.display;
    }
  } else if(phase.assigneeUser && phase.assigneeUser.userId === -1) {
    assigneeDisplay = 'Project Followers';
  } else if(phase.assigneeUsers) {
    if(phase.assigneeUsers.length == 1) {
      assigneeDisplay = phase.assigneeUsers[0].firstName;
      if(phase.assigneeUsers[0].lastName) {
        assigneeDisplay = assigneeDisplay + ' ' + phase.assigneeUsers[0].lastName;
      }
    } else if(phase.assigneeUsers.length > 1) {
      assigneeDisplay = phase.assigneeUsers.length + ' Reviewers';
    } else {
      assigneeDisplay = 'Auto Selected By OPAL-Marketing';
    }
} 

return assigneeDisplay
}
const disableBody = (target) => disableBodyScroll(target)
const enableBody = (target) => enableBodyScroll(target)
const CampaignModelTutorial = () =>{
 document.body.classList.add("modal-open-5");
 $(".nextFocus5").on("keydown", function (e) {
  if (e.key === Constants.TAB) {
    if (e.shiftKey === false) {
      e.preventDefault();
      $(".cancelFocus5").trigger("focus");
    }
  }
});
setTimeout(() => {
  $(".cancelFocus5").trigger("focus");
  $(".cancelFocus5").on("keydown", function (e) {
    if (e.key === Constants.TAB) {
      if (e.shiftKey === true) {
        e.preventDefault();
        $(".nextFocus5").trigger("focus");
      }
    }
  });
  $(".inner-lightbox-panel").on("keydown", function (e) {
    if (e.key === Constants.ESCAPE) {
      document.body.classList.remove("modal-open-5");
      $('.focusAdd').trigger('focus');
      $('.tutorial-tips').removeClass('focusAdd');
    }
  });
}, 500);
}
//Tutorial Tips end
const crumbs = [
   {label:'Projects', url:''},
 ];
  return (
    <>
      <div className="body bg-color">
        <div id="container" className="dashboard-wrapper tourslider-dots">
          <TourProvider steps={steps} styles={styles} prevButton={prevButton} nextButton={nextButton}
            afterOpen={disableBody} beforeClose={enableBody}
            onClickMask={({ currentStep, steps, setIsOpen }) => {
              if (steps) {
                if (currentStep === steps.length) {
                  setIsOpen(true);
                }
              }
            }}
            badgeContent={({ totalSteps, currentStep }) => currentStep + 1 + "/" + totalSteps}>
            <Header ref={scrollRef} showHelp={false} func={CampaignModelTutorial}/>
            <LeftNavbar />
          </TourProvider>

          <section className={activeTab !== "overView" ? "dashboard-content " : "dashboard-content" } ref={scrollRef} >
            {!showLoader ?
            <div id="content" className={ (activeTab === "tasks" || activeTab === "task") ? "dashboard-wrap project-task" : (activeTab === "changeOrder" ? "dashboard-wrap project-task change-order-page" : "dashboard-wrap campaign-section")}>
              <Breadcrumb crumbs={ crumbs } />
              <div className="wrap-data">
                <div className="white-bg project-detail-page">
                  <div className="project_details-overview flex">
                    <div className={activeTab === "overView" ? "left-content" : "left-content main"}>
                      <div className={activeTab === "overView" ? "left-content-inner" : ""}>
                        <div className="left-content-header">
                            <div className="name-card-section">
                              <div className="name-card-section-left">
                                <div className="campaign-name">
                                  <button aria-label="back" className="back-btn" onClick={navigateBack} >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none" >
                                      <path d="M6.46967 12.9697C6.17678 13.2626 6.17678 13.7374 6.46967 14.0303L11.2426 18.8033C11.5355 19.0962 12.0104 19.0962 12.3033 18.8033C12.5962 18.5104 12.5962 18.0355 12.3033 17.7426L8.06066 13.5L12.3033 9.25736C12.5962 8.96447 12.5962 8.48959 12.3033 8.1967C12.0104 7.90381 11.5355 7.90381 11.2426 8.1967L6.46967 12.9697ZM7 14.25H20V12.75H7V14.25Z"
                                        fill="#4D4D4D" />
                                    </svg>
                                  </button>
                                  <h3>{projectData?.resource?.projectResource.name}</h3>
                                  {  projectData?.resource?.projectResource?.userCanAlterProject && custBootstrapDataRedux?.permissions?.PROJECT_CUD && custBootstrapDataRedux?.roleSet?.customerType &&
                                  <button aria-label="Edit" className="name-edit" projectdetail-tour="edit">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17" viewBox="0 0 18 17" fill="none" onClick={editProject} >
                                      <path d="M0.25 15.25H17.75V16.5H0.25V15.25ZM14.875 4.625C15.375 4.125 15.375 3.375 14.875 2.875L12.625 0.625C12.125 0.125 11.375 0.125 10.875 0.625L1.5 10V14H5.5L14.875 4.625ZM11.75 1.5L14 3.75L12.125 5.625L9.875 3.375L11.75 1.5ZM2.75 12.75V10.5L9 4.25L11.25 6.5L5 12.75H2.75Z"
                                        fill="#1D4ED8" />
                                    </svg>
                                  </button>
                                  }
                                </div>
                                <div className="refresh-outer flex-center">
                                  <button aria-label="refresh" className="refresh" onClick={()=>refreshProject('',true)}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none" >
                                      <path d="M3.23915 4.2047L4.30182 3.87937C4.38556 3.85376 4.47352 3.8449 4.56068 3.85328C4.64785 3.86167 4.73251 3.88715 4.80983 3.92825C4.88715 3.96936 4.95562 4.02529 5.01132 4.09285C5.06702 4.16042 5.10887 4.2383 5.13448 4.32204C5.16009 4.40578 5.16895 4.49374 5.16057 4.5809C5.15218 4.66807 5.12671 4.75273 5.0856 4.83005C5.04449 4.90737 4.98856 4.97584 4.921 5.03154C4.85343 5.08724 4.77556 5.12909 4.69182 5.1547L2.14182 5.9347C2.05803 5.96032 1.97002 5.96917 1.88282 5.96074C1.79561 5.95232 1.71093 5.9268 1.63359 5.88562C1.55626 5.84445 1.4878 5.78844 1.43213 5.72079C1.37646 5.65314 1.33467 5.57518 1.30915 5.49137L0.52915 2.94137C0.503542 2.85763 0.494678 2.76967 0.503066 2.6825C0.511453 2.59534 0.536927 2.51068 0.578032 2.43336C0.619137 2.35604 0.67507 2.28757 0.742635 2.23186C0.810201 2.17616 0.888077 2.13431 0.971816 2.1087C1.14094 2.05698 1.32367 2.07457 1.47983 2.15758C1.63598 2.2406 1.75277 2.38225 1.80448 2.55137L2.09782 3.51204C3.70315 1.03937 6.88781 -0.023965 9.71515 1.1347C10.5607 1.48128 11.32 2.00893 11.9397 2.68054C12.5593 3.35215 13.0243 4.15139 13.3018 5.02204C13.3303 5.10591 13.3417 5.1946 13.3355 5.28295C13.3293 5.37129 13.3055 5.45752 13.2656 5.53658C13.2257 5.61564 13.1705 5.68597 13.1031 5.74344C13.0357 5.80091 12.9576 5.84438 12.8732 5.8713C12.7888 5.89823 12.6999 5.90808 12.6117 5.90027C12.5235 5.89246 12.4377 5.86715 12.3594 5.82583C12.281 5.7845 12.2117 5.72797 12.1555 5.65956C12.0993 5.59115 12.0572 5.51221 12.0318 5.42737C11.7502 4.54295 11.2241 3.75623 10.5144 3.15803C9.80469 2.55984 8.94027 2.17458 8.02093 2.04673C7.10159 1.91889 6.16485 2.05367 5.31885 2.43551C4.47285 2.81735 3.75209 3.43069 3.23982 4.2047H3.23915ZM11.4571 9.66804L10.2738 9.96337C10.1881 9.98687 10.0986 9.993 10.0105 9.98141C9.92244 9.96982 9.83756 9.94073 9.76087 9.89587C9.68418 9.85101 9.61724 9.79127 9.56396 9.72016C9.51069 9.64906 9.47217 9.56802 9.45067 9.48182C9.42916 9.39561 9.4251 9.30598 9.43873 9.21818C9.45236 9.13039 9.4834 9.0462 9.53002 8.97057C9.57665 8.89494 9.63792 8.8294 9.71024 8.77779C9.78256 8.72618 9.86447 8.68954 9.95115 8.67004L12.3798 8.06404C12.5064 8.00383 12.6487 7.98517 12.7865 8.0107C12.9192 8.02817 13.0437 8.0852 13.1435 8.17438C13.2434 8.26357 13.3141 8.38076 13.3465 8.5107L13.9918 11.0974C14.03 11.2673 14.0003 11.4454 13.9089 11.5936C13.8175 11.7418 13.6717 11.8484 13.5028 11.8906C13.3338 11.9327 13.1551 11.9071 13.0048 11.8192C12.8545 11.7312 12.7445 11.588 12.6985 11.42L12.4785 10.5387C11.8366 11.4624 10.9575 12.1959 9.93368 12.6619C8.90991 13.1279 7.77941 13.3092 6.66126 13.1866C5.54312 13.0641 4.47873 12.6422 3.58022 11.9655C2.68171 11.2887 1.98235 10.3822 1.55582 9.34137L1.38248 8.9187C1.3493 8.83768 1.33241 8.75091 1.33276 8.66335C1.33311 8.5758 1.3507 8.48917 1.38454 8.40841C1.41837 8.32766 1.46777 8.25436 1.52993 8.19269C1.59209 8.13103 1.66579 8.08222 1.74682 8.04904C1.91045 7.98202 2.09401 7.98276 2.25711 8.05109C2.33786 8.08492 2.41116 8.13433 2.47282 8.19649C2.53449 8.25865 2.5833 8.33234 2.61648 8.41337L2.78982 8.83537C3.12965 9.66459 3.68948 10.3853 4.40889 10.9196C5.1283 11.454 5.97998 11.7817 6.87202 11.8675C7.76405 11.9532 8.66258 11.7938 9.47062 11.4063C10.2787 11.0188 10.9655 10.418 11.4571 9.6687V9.66804Z"
                                        fill="#128FEB" />
                                    </svg>
                                  </button>
                                  <div className="progress">
                                    {showProjectStatusLoader?RotatingLinesIcon(true,"15"):projectData?.resource?.projectResource.status?.code === "extract_xliff_from_offline_files" ? "Extracting Translatable Content" : projectData?.displayName[0].status.display}
                                  </div>
                                </div>
                              </div>
                              {projectData?.resource?.projectResource?.projectContentType!=='post' && projectData?.resource?.projectResource?.projectContentType!='page' && projectData?.resource?.projectResource?.userCanAlterProject && permission?.PROJECT_CUD  ?
                              <div className="name-card-section-right">
                                {projectData.displayName[0].status.bidSelected && !projectData.displayName[0].status.closed && projectData?.resource?.projectResource.deliveryStatus !== ''  ?
                                Constants.PROJECT_DELIVERY_STATUS[projectData?.resource?.projectResource.deliveryStatus] !== '' ?
                                  <div className="progress readonly" tabIndex="-1">{Constants.PROJECT_DELIVERY_STATUS[projectData?.resource?.projectResource.deliveryStatus]}</div>: '' : ''}
                                <div className="circle projectDeatilsDot" onClick={showHide} onKeyDown={(e) => handleDotEscFocus(e)}
                                  role="button" aria-label="Task Type" aria-expanded="false" tabIndex="0" projectdetail-tour="clone-project" >
                                  <div className="dots">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                    <div className="triangle-with-shadow"></div>
                                  </div>
                                </div>
                                <div className="progress-btn" id="progress-btn" onKeyDown={(e) => handleDotModalFocus(e)}>
                                  <div className="inner-popover project-btn">
                                    <button id="cloneProject" className="btn" onClick={cloneProject}> {translate("project_listing.cp")}</button>
                                    {(projectData?.resource?.projectResource.status?.code === "cancelled" ||
                                    projectData?.resource?.projectResource.status?.code === "project_closed" ||
                                    projectData?.resource?.projectResource.status?.code === "in_cancellation_waiting_for_customer" ||
                                    projectData?.resource?.projectResource.status?.code === "in_cancellation_waiting_for_vendor")
                                    ? Constants.BLANK
                                    : <button className="dashboard-btn" onClick={showCancelProjectPopup}>{translate("project_listing.cancel_project")}</button>}
                                    {
                                      ((projectData?.resource?.projectResource.status?.code === "project_closed" && templateExist)?
                                      <button className="dashboard-btn" onClick={(e)=>showAddModal()}>{translate("project_listing.save_as_template")}</button>
                                      :Constants.BLANK)
                                    }

                                  </div>
                                </div>
                              </div>:Constants?.BLANK}
                            </div>
                            <div className="listing-tab-block flex">
                              <ul className="listing-tab-link flex" role="tablist">
                                <li role="none">
                                  <button role="tab" aria-label={activeTab === "overView" ? "Current tab " + translate("project_listing.overview") : translate("project_listing.overview")}
                                    aria-selected={activeTab === "overView" ? "true" : "false"} className={activeTab === "overView" ? "active" : ""}
                                    onClick={() => clearStateOpenTab()} >
                                    {translate("project_listing.overview")}
                                  </button>
                                </li>
                                <li role="none">
                                  <button role="tab" aria-label={activeTab === "projectDetail" ? "Current tab, project Detail" : "project Detail"}
                                    aria-selected={activeTab === "projectDetail" ? "true" : "false"} className={activeTab === "projectDetail" ? "active" : ""}
                                    onClick={() => setActiveSection("projectDetail")} projectdetail-tour="projectdetails-tab" >
                                    Project Details
                                  </button>
                                </li>
                                <ConditionalBlock condition={projectData?.resource.tabs.findIndex(data=>data.tabId ==="tab_source") !==-1}>
                                <li role="none">
                                  <button role="tab" aria-label={activeTab === "sourceFile" ? "Current tab " + translate("project_listing.source_file") : translate("project_listing.source_file")}
                                    aria-selected={activeTab === "sourceFile" ? "true" : "false"} className={activeTab === "sourceFile" ? "active" : ""}
                                    onClick={() => setActiveSection("sourceFile")} >
                                    {translate("project_listing.source_file")}
                                  </button>
                                </li>
                                </ConditionalBlock>
                                {!isOnlyReviewer() && projectData?.resource?.projectResource?.projectVendorType === "EXTERNAL_BIDLESS" ?
                                <li role="none">
                                <button role="tab" aria-label={activeTab === "translationRequest" ? "Current tab, translation Request" : "translation Request"}
                                  aria-selected={activeTab === "translationRequest" ? "true" : "false"} className={activeTab === "translationRequest" ? "active" : ""}
                                  onClick={() => setActiveSection("translationRequest")} projectdetail-tour="translation-tab">
                                Translation request  </button>
                              </li> :
                              !isOnlyReviewer() && projectData?.resource?.projectResource.projectVendorType === "INTERNAL" ?
                              <li role="none">
                                <button role="tab" aria-label={activeTab === "internalTranslator" ? "Current tab, internal Translator" : "internal Translator"}
                                  aria-selected={activeTab === "internalTranslator" ? "true" : "false"} className={activeTab === "internalTranslator" ? "active" : ""}
                                  onClick={() => setActiveSection("internalTranslator")} >
                                  Internal Translator
                                </button>
                              </li> :
                              !isOnlyReviewer() &&  projectData?.resource?.projectResource?.projectVendorType === "MACHINE_TRANSLATION" ?
                              <li role="none">
                              <button role="tab" aria-label={activeTab === "machineTranslation" ? "Current tab, machine Translation" : "machine Translation"}
                                aria-selected={activeTab === "machineTranslation" ? "true" : "false"} className={activeTab === "machineTranslation" ? "active" : ""}
                                onClick={() => setActiveSection("machineTranslation")} >
                                Estimate
                              </button>
                            </li>
                              :
                              !isOnlyReviewer() ?(
                              <li role="none">
                              <button role="tab" aria-label={activeTab === "bids" ? "Current tab, Quotes" : "Quotes"}
                                aria-selected={activeTab === "bids" ? "true" : "false"} className={activeTab === "bids" ? "active" : ""}
                                onClick={() => setActiveSection("bids")} >
                                Quotes
                              </button>
                            </li>
                              ) : null
                              }

                                <li role="none">
                                  <button role="tab" aria-label={(activeTab === "tasks" || activeTab === "task")? "Current tab " + translate("project_listing.tasks") : translate("project_listing.tasks")}
                                    aria-selected={activeTab === "tasks" ? "true" : "false"} className={(activeTab === "tasks" || activeTab === "task") ? "active" : ""}
                                    onClick={() => setActiveSection("tasks")}>
                                    {translate("project_listing.tasks")}
                                  </button>
                                </li>
                                {!isOnlyReviewer() && projectData?.resource?.projectResource?.projectVendorType !== "MACHINE_TRANSLATION" ?(
                                <li role="none">
                                  <button role="tab" aria-label={activeTab === "changeOrder" ? "Current tab " + translate("project_listing.change_order") : translate("project_listing.change_order")}
                                    aria-selected={activeTab === "changeOrder" ? "true" : "false"} className={activeTab === "changeOrder" ? "active" : ""}
                                    onClick={() => setActiveSection("changeOrder")} projectdetail-tour="changeorder-tab" >
                                    {translate("project_listing.change_orders")}
                                  </button>
                                </li>
                                ) : null }
                                <li role="none">
                                  <button role="tab" aria-label={activeTab === "discussions" ? "Current tab, discussions" : "discussions"}
                                    aria-selected={activeTab === "discussions" ? "true" : "false"} className={activeTab === "discussions" ? "active" : ""}
                                    onClick={() => setActiveSection("discussions")} projectdetail-tour="discussion-tab" >
                                    Discussions {unreadDiscussionCount>0?<span>{unreadDiscussionCount}</span>:''}
                                  </button>
                                </li>
                                {custBootstrapDataRedux?.features?.PRE_TRANSLATION_TM_LEVERAGING  && 
                                <li role="none">
                                  <button role="tab" aria-label={activeTab === "leverage-tm" ? "Current tab, leverage-tm" : "leverage-tm"}
                                    aria-selected={activeTab === "leverage-tm" ? "true" : "false"} className={activeTab === "leverage-tm" ? "active" : ""}
                                    onClick={() => setActiveSection("leverage-tm")} projectdetail-tour="discussion-tab" >
                                    Pre-Translation Summary
                                  </button>
                                </li>
                                }
                              </ul>
                            </div>
                        </div>
                        {projectData !== undefined
                          ? (() => {                              
                              switch (activeTab) {
                                case "overView":
                                  return <Overview  refreshProject={setRefreshProjectData} projectDetail={projectData} refresh={refreshProject} funct={redirectToTab} showTabWithId={showTabWithId}
                                  trigger={trigger} languageCode={langCode} getAssignee={getAssigneeDisplay} refreshActivityData={getActivityData}/>;
                                case "projectDetail":
                                  return (<ProjectDetailTab projectDetail={projectData} refresh={refreshProject} getAssignee={getAssigneeDisplay} />);
                                case "sourceFile":
                                  return <SourceFile departmentId={projectData.resource.projectResource.userGroup.id} funct={redirectToTab} projectDetail={projectData} refresh={refreshProject}/>;
                                case "bids":
                                  return <Bids projectDetail={projectData} refresh={refreshProject}/>;
                                case "machineTranslation":
                                  return <Estimate projectDetail={projectData} refresh={refreshProject}/>;  
                                case "translationRequest"   :
                                  return <TranslationRequest projectDetail={projectData} refresh={refreshProject}/>;
                                case "internalTranslator"   :
                                  return <InternalTranslator projectDetail={projectData} refresh={refreshProject}/>;
                                case "tasks":
                                case "task":
                                  return <Tasks projectDetail={projectData} funct={redirectToTab} taskId={taskId} showTabWithId={showTabWithId}/>;
                                case "changeOrder":
                                  return <ChangeOrder projectDetail={projectData} changeOrderId={changeOrderId} funct={redirectToTab}/>;
                                case "discussions":
                                  return <Discussion decreaseMessageCount={decreaseMessageCount} isRedirect={alertRedirect} discussionsId={discussionsId}/>;
                                case "leverage-tm":
                                  return <LeveragedTm projectDetail={projectData}/>;
                                default:
                                  return Constants.BLANK;
                              }
                          })()
                          : Constants.BLANK}
                      </div>
                    </div>
                    {activeTab === "overView" ? (
                      <div className="right-content activity-main project-detail">
                        <h5>{translate("project_listing.activity_feed")}</h5>
                        <div className="activity-feed-outer">
                          {recentActivity?.length !== 0 ? (
                            recentActivity?.events.map((activity, index) => {
                              return (
                                <div key={index}>
                                  {compareDateWithCurrent(activity.createdDate, Constants.DATE_COMPARE_FORMAT) ? (
                                    <div className="activity-feed-inner">
                                        {index === 0 ? (<span className="title"> Today</span>) : ("")}
                                        <ul className="activity-feed-table">
                                          <li>
                                            <span>
                                              {utcDateTimeWithTimeZoneWithFormat(activity.createdDate, Constants.HOUR_MIN_AM_PM,custBootstrapDataRedux?.user?.timeZone)}
                                            </span>
                                            <p dangerouslySetInnerHTML={{__html: activity.output}}
                                           onClick={(e)=> redirectToActivity(e,activity)} >
                                            </p>
                                          </li>
                                        </ul>
                                    </div>
                                  ) :
                                  (
                                    <div className="activity-feed-inner">
                                      {index !== 0 ? 
                                        (recentActivity.events[index - 1]?.createdDate.date !== recentActivity.events[index].createdDate.date ?
                                          ( <span className="title">
                                            {activity.createdDate.date}
                                          </span> ) : (Constants.BLANK))
                                        : ( <span className="title">
                                            {activity.createdDate.date}
                                          </span>)
                                          }
                                        <ul className="activity-feed-table">
                                          <li>
                                            <span>
                                              {activity.createdDate.timeOfDay}
                                            </span>
                                            <p dangerouslySetInnerHTML={{__html: activity.output}}
                                              onClick={(e)=>{redirectToActivity(e,activity)}}>
                                            </p>
                                          </li>
                                        </ul>
                                    </div>
                                  )}
                                </div>
                                );
                              })
                              ) : (
                              <div className="no-data-display align-center">
                                <i className="nodata-icon"></i>
                                <p>{Constants.NO_DATA_FOUND}</p>
                              </div>
                            )}
                          </div>
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
            :
            <div style={{ textAlign: "center" }}>
              <RotatingLines strokeColor="grey" strokeWidth="5" width="96" visible={true} />
            </div>}
            {successMsg?.length > 0 ? <SuccessMessage message={successMsg} /> :Constants.BLANK}
            {errorMsg?.length > 0 ? <ErrorMessage message={errorMsg} /> :Constants.BLANK}
          </section>
        </div>
      </div>
      <AddProjectTemplate projectId={projectData?.resource?.projectResource?.id} setSuccessMsg={setSuccessMsg} refreshProject={refreshProject} setErrorMsg={setErrorMsg} projectName={projectData?.resource?.projectResource.name}/>
    </>
  );
}
